// LOGIN
// export const Login = () =>
//   import(/* webpackChunkName: "login" */ '@/components/authentication/Login')
// export const LostPassword = () =>
//   import(
//     /* webpackChunkName: "login" */ '@/components/authentication/LostPassword'
//   )

// MATCHES
export const Matches2 = () =>
  import(
    /* webpackChunkName: "matches" */ '@/components/apps/matches/Dashboard2'
  )
export const MatchForm = () =>
  import(
    /* webpackChunkName: "matches" */ '@/components/apps/matches/FormManager2'
  )
export const MatchView = () =>
  import(
    /* webpackChunkName: "matches" */ '@/components/apps/matches/MatchView2'
  )
export const MatchList = () =>
  import(/* webpackChunkName: "matches" */ '@/components/apps/matches/List2')

export const TrainingList = () =>
  import(
    /* webpackChunkName: "trainings" */ '@/components/apps/trainings/TrainingList'
  )
export const TrainingForm = () =>
  import(
    /* webpackChunkName: "trainings" */ '@/components/apps/trainings/TrainingForm'
  )
export const TrainingView = () =>
  import(
    /* webpackChunkName: "trainings" */ '@/components/apps/trainings/TrainingView'
  )

export const SubscriptionList = () =>
  import(
    /* webpackChunkName: "subscriptions" */ '@/components/management/subscriptions/SubscriptionList'
  )
// export const Profile = () =>
//   import('@/components/configuration/profile/ProfileView')
// export const Provinces = () =>
//   import('@/components/configuration/location/provinces/Dashboard')
// export const Countries = () =>
//   import('@/components/configuration/location/countries/Dashboard')
// export const Towns = () =>
//   import('@/components/configuration/location/towns/Dashboard')
// export const Roles = () => import('@/components/management/roles/Dashboard')
// export const Categories = () =>
//   import('@/components/management/categories/Dashboard')
// export const Courses = () => import('@/components/management/courses/Dashboard')
// export const Home = () => import('@/components/Home')
// export const Users = () => import('@/components/management/users/Dashboard')
// export const Languages = () =>
//   import('@/components/configuration/languages/Dashboard')
// export const Trainings = () => import('@/components/apps/trainings/Dashboard')
// export const Tournaments = () =>
//   import('@/components/apps/tournaments/Dashboard')
// // export const Notification = () =>
// //   import('@/components/apps/notifications/notifications')
// export const Entities = () =>
//   import('@/components/management/entities/Dashboard')
// export const Stadiums = () =>
//   import('@/components/management/stadiums/Dashboard')
// export const Teams = () => import('@/components/management/teams/Dashboard')
// export const Cameras = () => import('@/components/management/cameras/Dashboard')

// export const AcceptInvitation = () =>
//   import('@/components/management/teams/AcceptInvitation')
